export default "__VITE_ASSET__dfe8ca11__"